exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1NGbo{background:#f3d8d8}._1-Nv_{background:#bce0bc}.BBtZa{background:#fff}._3gqwr{padding:0!important}._2fdGs{padding:7px 3px}._1Fpa9 div{overflow-x:hidden!important}._1Fpa9 div div div div{overflow:hidden!important}", ""]);

// exports
exports.locals = {
	"pendiente": "_1NGbo",
	"procesada": "_1-Nv_",
	"normal": "BBtZa",
	"tdClear": "_3gqwr",
	"field": "_2fdGs",
	"hidden": "_1Fpa9"
};